export { default as getRoles } from './getRoles';

export type { GetRolesFunction, GetRolesPayload, Role, Translation } from './getRoles.type';
